import { atom } from 'jotai';

import { PlanItemType } from '@/hooks/queries/pay/usePayPlan';

export const PricePlanInfoAtom = atom<PlanItemType[] | null>(null);

export const CouponAppliedAtom = atom<boolean>(false);

export const SelectedPlanAtom = atom<null | PlanItemType>(null);
